"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantInVariantUpdateSuggestionRequest = instanceOfVariantInVariantUpdateSuggestionRequest;
exports.VariantInVariantUpdateSuggestionRequestFromJSON = VariantInVariantUpdateSuggestionRequestFromJSON;
exports.VariantInVariantUpdateSuggestionRequestFromJSONTyped = VariantInVariantUpdateSuggestionRequestFromJSONTyped;
exports.VariantInVariantUpdateSuggestionRequestToJSON = VariantInVariantUpdateSuggestionRequestToJSON;
exports.VariantInVariantUpdateSuggestionRequestToJSONTyped = VariantInVariantUpdateSuggestionRequestToJSONTyped;
/**
 * Check if a given object implements the VariantInVariantUpdateSuggestionRequest interface.
 */
function instanceOfVariantInVariantUpdateSuggestionRequest(value) {
    if (!('variant' in value) || value['variant'] === undefined)
        return false;
    return true;
}
function VariantInVariantUpdateSuggestionRequestFromJSON(json) {
    return VariantInVariantUpdateSuggestionRequestFromJSONTyped(json, false);
}
function VariantInVariantUpdateSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'variant': json['variant'],
        'issue': json['issue'] == null ? undefined : json['issue'],
    };
}
function VariantInVariantUpdateSuggestionRequestToJSON(json) {
    return VariantInVariantUpdateSuggestionRequestToJSONTyped(json, false);
}
function VariantInVariantUpdateSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'variant': value['variant'],
        'issue': value['issue'],
    };
}
//# sourceMappingURL=variantInVariantUpdateSuggestionRequest.js.map